import { ICalendarioMaquina } from 'src/app/usuarios/models/IMaquinaFecha';
import * as storage from '../../core/store/root/storage';
import { IMaquinaEstadoResponse } from '../models/maquina';
export const MaquinasFeatureKey = 'maquinas';
export interface IMaquinasState {
  usuarioId: number;
  maquinas: IMaquinaEstadoResponse;
  calendario: ICalendarioMaquina[];
}

export const initialMaquinaState: IMaquinasState = {

  usuarioId: storage?.getItem('maquinas').userId,
  maquinas: {
    estadoActualMaquinas: [],
    maquinas: []
  }, // storage.getItem('maquinas').maquinas,
  calendario: [],
};
